import React from 'react';
import PropTypes from 'prop-types';

import TopNav from './TopNav';
import AccountDropdown from './AccountDropdown';
const CommentWidget = require('../../nav/CommentWidget');
import HelpDropdown from '../../nav/HelpDropdown';
import UpgradeIndividualPromoButton from '../../nav/UpgradeIndividualPromoButton';

const propTypes = {
    onClickBrandLogo: PropTypes.func,
    onClickAvatar: PropTypes.func,
    children: PropTypes.node,
    logoLinkDisable: PropTypes.bool,
    hideAccountDropdown: PropTypes.bool,
    role: PropTypes.string, // Globals.users.local_role_type ( STUDENT or AUTHOR )
};

const defaultProps = {
    onClickBrandLogo: null,
    children: null,
    logoLinkDisable: false,
    hideAccountDropdown: false
};

function MainNav(props) {
    const showCommentWidget = !(props.logoLinkDisable || props.hideAccountDropdown); // TBD
    return (
        <TopNav
            leftChildren={props.children}
            onClickBrandLogo={props.onClickBrandLogo}
            logoLinkUrl={props.logoLinkUrl}
            logoLinkDisable={props.logoLinkDisable || !props.onClickBrandLogo}
            role={props.role}
        >
            <UpgradeIndividualPromoButton />
            {(showCommentWidget) &&
                <CommentWidget />
            }
            <HelpDropdown minimizeBreakpoint="md" />
            <AccountDropdown role={props.role} minimizeBreakpoint="md" />
        </TopNav>
    );
}

MainNav.propTypes = propTypes;
MainNav.defaultProps = defaultProps;

export default MainNav;
